import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="relative w-full">
      <div class="flex gap-1 w-full">
        @if (progressPercent > 0) {
          <div
            class="h-1 rounded-full bg-primary transition-all duration-500 ease-out"
            [style.flex-grow]="progressPercent"
          ></div>
        }
        @if (progressPercent < 100) {
          <div
            class="h-1 rounded-full transition-all duration-500 ease-out"
            style="background-color: #baeaff"
            [style.flex-grow]="100 - progressPercent"
          ></div>
        }
      </div>
      <div
        class="absolute top-0 right-0 w-1 h-1 rounded-full bg-primary transition-opacity duration-500"
        [class.opacity-0]="progressPercent >= 100"
      ></div>
    </div>
  `,
})
export class ProgressIndicatorComponent {
  @Input() totalSteps = 6;
  @Input() currentIndex = 0;

  get progressPercent(): number {
    if (this.totalSteps <= 0) return 0;
    return Math.min(100, (this.currentIndex / this.totalSteps) * 100);
  }
}
